export default __webpack_public_path__ + "static/media/halal.2bd848aa.svg";